module.exports = __webpack_public_path__ + "img/5_62.7bb5fa59.png";